/**
 * Asset enums - SOURCE OF TRUTH
 * Pure TypeScript - no Drizzle imports
 */
// Asset type labels
export const assetTypeLabels = {
    video: 'Video',
    image: 'Image',
};
export const assetTypeValues = Object.keys(assetTypeLabels);
// Placeholder type labels
export const placeholderTypeLabels = {
    owner_bodyshot: 'Owner Photo',
    owner_headshot: 'Owner Headshot',
    staff_photo: 'Staff Photo',
    client_result: 'Client Result',
    before: 'Before Photo',
    after: 'After Photo',
    location_exterior: 'Location Exterior',
    location_interior: 'Location Interior',
    product: 'Product Photo',
    procedure_generic: 'Procedure Photo',
    procedure_teeth_whitening: 'Teeth Whitening',
    procedure_haircut: 'Haircut',
    procedure_manicure: 'Manicure',
    procedure_facial: 'Facial',
    procedure_massage: 'Massage',
    procedure_tattoo: 'Tattoo',
    brand_logo: 'Brand Logo',
    other: 'Other',
};
export const placeholderTypeValues = Object.keys(placeholderTypeLabels);
// Asset analysis status labels
export const assetAnalysisStatusLabels = {
    queued: 'Queued',
    processing: 'Processing',
    completed: 'Completed',
    failed: 'Failed',
};
export const assetAnalysisStatusValues = Object.keys(assetAnalysisStatusLabels);
// Asset content type labels
export const assetContentTypeLabels = {
    talking_head: 'Talking Head',
    procedure: 'Procedure',
    environment: 'Environment',
    testimonial: 'Testimonial',
    result: 'Result',
    other: 'Other',
};
export const assetContentTypeValues = Object.keys(assetContentTypeLabels);
// All valid content type TAG values (what goes in asset.tags)
export const assetContentTypeTagLabels = {
    before: 'Before',
    after: 'After',
    procedure: 'Procedure',
    environment: 'Environment',
    'employee-talking-head': 'Employee / Talking Head',
    testimonial: 'Testimonial',
    'pending-result': 'Pending Result',
    other: 'Other',
};
export const assetContentTypeTagValues = Object.keys(assetContentTypeTagLabels);
// Map from AI contentType enum → tag value
export const contentTypeToTagMap = {
    procedure: 'procedure',
    environment: 'environment',
    talking_head: 'employee-talking-head',
    testimonial: 'testimonial',
    result: 'pending-result',
    other: 'other',
};
// Asset source labels (raw footage vs edited/polished vs curated stock)
export const assetSourceLabels = {
    raw: 'Raw Footage',
    edited: 'Edited / Polished',
    // Derived from a curated stock_clip on copy-on-attach. Pre-transcoded, so
    // these never flow through probe/transcode and are excluded from AI analysis.
    stock: 'Stock Footage',
    // The creative behind an ad imported from Meta Ads Manager, copied into the
    // org's bucket at import/sync so Claire and the dashboard read OUR file,
    // never Meta's expiring CDN URL or its 64px thumbnail. Excluded from the
    // raw-footage AI analysis; summarised by the ad-creative-ingest job instead.
    meta_ad: 'Meta Ad Creative',
};
export const assetSourceValues = Object.keys(assetSourceLabels);
// Asset upload batch status labels
export const assetUploadBatchStatusLabels = {
    pending: 'Pending',
    processing: 'Processing',
    completed: 'Completed',
    partial: 'Partial (some failed)',
    failed: 'Failed',
};
export const assetUploadBatchStatusValues = Object.keys(assetUploadBatchStatusLabels);
//# sourceMappingURL=assets.js.map